import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PostService } from '../../services/post.service';

@Component({
  selector: 'ibero-survey',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './survey.html',
  styleUrl: './survey.css'
})
export class Survey implements OnInit {
  @Input() survey: any;
  @Input() post_id!: number;
  selectedOptionId: number | null = null;

  constructor(private postService: PostService) {}

  ngOnInit() {
    // Initialize selectedOptionId with my_vote if it exists
    if (this.survey && this.survey.my_vote) {
      this.selectedOptionId = this.survey.my_vote;
    }
  }

  submitSurvey() {
    console.log('Submit method called');
    if (this.selectedOptionId) {
  
      const dataSurvey = {
        action: 'survey',
        survey: String(this.selectedOptionId)
      };

      console.log('Submitting survey data:', dataSurvey);

      this.postService.responseSurveyOptions(this.post_id, dataSurvey)
        .subscribe({
          next: (response) => {
            console.log('Survey submitted successfully:', response);
            this.selectedOptionId = null; // Reset form
          },
          error: (error) => {
            console.error('Error submitting survey:', error);
          }
        });
    }
  }

  onOptionSelect(option: any) {
    // console.log('Option selected:', option);
    this.submitSurvey();
  }

  calculatePercentage(votes: number): number {
    const totalVotes = this.survey.survey_options.reduce(
      (sum: number, option: any) => sum + option.votes, 
      0
    );
    
    if (totalVotes === 0) return 0;
    
    return Math.round((votes / totalVotes) * 100);
  }
}
